// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"styles_PrivacyPolicy__1_HY1","parentList":"styles_parentList__1lybo","childList":"styles_childList__1wzIA"};